import { Route, Routes, Navigate } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";
import useIsEvent from "./service/UseEvent";
import Home from "./page/Client/home";
import InfoClient from "./page/Client/Checkout";
import Panier from "./page/Client/Panier";
import ImageUpload from "./page/Client/UploadImagePage";
import Login from "./page/Admin/auth/login";
import PageCommand from "./page/Admin/magasin/PageCommad";
import PageImprimant from "./page/Admin/all/PageImprimant";
import PageSearchCommand from "./page/Admin/magasin/PageSearchCommand";
import PageCommandTraiteParCode from "./page/Admin/magasin/PageCommandTraiteParcode";
import PageImageToday from "./page/Admin/Events/PageImageToday";
import PageCommandClient from "./page/Admin/magasin/CommandClientPage";
import Pagedashboard from "./page/Admin/magasin/PageDashboard";
import TestRollete from "./page/Client/testRoulete";

import HashtagsPage from "./page/Admin/magasin/HashtagsPage";
import PageDemention from "./page/Admin/all/PageDimension";
import PageParametre from "./page/Admin/magasin/PageParametre";
import PageTakeImage from "./page/Admin/Events/PageTakeImage";
import EventCodePage from "./page/Client/Events/EventCodePage";
import EventUploadPage from "./page/Client/Events/EventUploadPage";
import Cookies from "js-cookie";
import PageCommandEventDashbord from "./page/Admin/Events/PageCommandEvent";
//import PageReduction from "./page/Admin/magasin/PageReduction";

const privateRoutes = [
  { path: "/admin", element: <Pagedashboard />, roles: ["gerant"] },
  {
    path: "/admin/command",
    element: <PageCommand />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imprimant",
    element: <PageImprimant />,
    roles: ["gerant"],
  },
  {
    path: "/admin/Dimension",
    element: <PageDemention />,
    roles: ["gerant"],
  },
  {
    path: "/admin/searchCommand",
    element: <PageSearchCommand />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/imageTraite/:id",
    element: <PageCommandTraiteParCode />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/ImageTodayPage/",
    element: <PageImageToday />,
    roles: ["gerant", "staff"],
  },
  {
    path: "/admin/CommandClientPage/:id",
    element: <PageCommandClient />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/hashtags",
    element: <HashtagsPage />,
    roles: ["gerant"],
  },
  {
    path: "/admin/Parametre",
    element: <PageParametre />,
    roles: ["gerant"],
  },
  {
    path: "/admin/takeImage",
    element: <PageTakeImage />,
    roles: ["user", "gerant"],
  },
  {
    path: "/admin/Event",
    element: <PageCommandEventDashbord />,
    roles: ["user", "gerant"],
  },
  //  { path: "/admin/reduction", element: <PageReduction />, roles: ["gerant"] },
];

function IndexRoute() {
  const { IsAuth, user } = useSelector((state) => state.Auth);
  const role = user?.Role ?? ""; // ← حماية ضد undefined

  const [isEvent] = useIsEvent();

  return (
    <BrowserRouter>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/produit/:type" element={<ImageUpload />} />
        <Route path="/panier" element={<Panier />} />
        <Route path="/commande/:type" element={<InfoClient />} />
        <Route path="/TestRollete" element={<TestRollete />} />
        <Route
          path="/EventCodePage"
          element={isEvent ? <Navigate to="/event" /> : <EventCodePage />}
        />
        <Route
          path="/event"
          element={
            isEvent ? <EventUploadPage /> : <Navigate to="/EventCodePage" />
          }
        />
        <Route
          path="/login"
          element={IsAuth ? <Navigate to="/admin/command" /> : <Login />}
        />
        {privateRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              IsAuth && route.roles.includes(role) ? (
                route.element
              ) : (
                <Navigate state={{ from: route.path }} to="/login" />
              )
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default IndexRoute;
